import { render, staticRenderFns } from "./VText.vue?vue&type=template&id=652cb579&scoped=true"
import script from "./VText.vue?vue&type=script&lang=js"
export * from "./VText.vue?vue&type=script&lang=js"
import style0 from "./VText.vue?vue&type=style&index=0&id=652cb579&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "652cb579",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\cxy\\project\\zcy\\zcy-dataEase\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('652cb579')) {
      api.createRecord('652cb579', component.options)
    } else {
      api.reload('652cb579', component.options)
    }
    module.hot.accept("./VText.vue?vue&type=template&id=652cb579&scoped=true", function () {
      api.rerender('652cb579', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/canvas/customComponent/VText.vue"
export default component.exports